module.exports = __webpack_public_path__ + "static/media/manualicon.a4a0495b.svg";